import React, { useState } from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { Button } from 'tabler-react';
import './forgotpassword.css';
import { useAPI } from '../../ApiCalls/useAPI';
import ReCAPTCHA from 'react-google-recaptcha';

const ForgotPassword = () => {
    const [flag, setFlag] = useState(false);
    const [isVerfied, setisVerfied] = useState(false);
    const [mobnum, setMobnum] = useState('');
    const [sid, setSid] = useState('');
    const [status, setStatus] = useState(['', '']);

    function checkmobnum() {
        let num = document.getElementById('mobnum').value;
        if (sid !== '' && mobnum !== '') {
            setFlag(true);
        }
        if (/^[0]?[6789]\d{9}$/.test(num)) {
            document.getElementById('mobnum-msg').innerText = '';
            document.getElementById('mobnum').classList.remove('is-invalid');
            document.getElementById('mobnum').classList.add('is-valid');
            setMobnum(num);
        } else {
            document.getElementById('mobnum-msg').innerText =
                'Enter a valid mobile number';
            document.getElementById('mobnum').classList.remove('is-valid');
            document.getElementById('mobnum').classList.add('is-invalid');
            setMobnum('');
            setFlag(false);
        }
    }
    function checksid() {
        let id = document.getElementById('sid').value;
        setSid(id);
        if (id !== '' && mobnum !== '') {
            setFlag(true);
        } else {
            setFlag(false);
        }
    }

    function clearformsuccess() {
        document.getElementById('mobnum').value = '';
        setMobnum('');
        document.getElementById('sid').value = '';
        setSid('');
    }
    function clearformerror() {
        document.getElementById('sid').value = '';
        setSid('');
    }

    function onSubmitClicked() {
        const { forgotPassword } = useAPI();
        if (flag && isVerfied) {
            forgotPassword(mobnum, sid)
                .then((response) => {
                    // console.log(response);
                    if (response.success) {
                        setStatus(['green', response.message]);
                        clearformsuccess();
                    } else {
                        setStatus(['red', response.message]);
                        clearformerror();
                    }
                })
                .catch((error) => console.error(error));
        }
    }
    function onChange() {
        setisVerfied(true);
        // console.log('verified true');
    }

    return (
        <div className="forgotpasscontent">
            <div className="logodiv">
                <img src="./images/kmit_sanjaya_logo.png" className="logo mb-4" alt="logo" />
            </div>
            <div id="form">
                <h4 id="headerTitle" className="forgotpasshead">
                    Forgot Password
                </h4>
                <div>
                    <div className="mt-2 forgotpassrow form-group">
                        <label className="forgotpass_label form-label">
                            Mobile Number
                        </label>
                        <input
                            className="form-control"
                            id="mobnum"
                            type="tel"
                            onChange={checkmobnum}
                            placeholder="Mobile Number Here"
                        />
                        <div id="mobnum-msg"></div>
                    </div>
                    <div className="mt-2 forgotpassrow form-group">
                        <label className="forgotpass_label form-label">
                            Sanjaya ID
                        </label>
                        <input
                            className="form-control"
                            id="sid"
                            onChange={checksid}
                            placeholder="Sanja ID here"
                        />
                        <div id="sid-msg"></div>
                    </div>
                    <div className="mt-2 recaptcha form-group">
                        <ReCAPTCHA
                            sitekey="6LeyMvQcAAAAACi34_IwdYINFh4C4pdBvFSkqcHR"
                            onChange={onChange}
                        />
                    </div>
                    <div id="button" className="forgotpassrow">
                        <Button
                            color="primary"
                            className="mt-4"
                            disabled={!(flag && isVerfied)}
                            onClick={onSubmitClicked}
                        >
                            Submit
                        </Button>
                    </div>
                    <div className="mt-4">
                        <h5 style={{ color: `${status[0]}` }}>{status[1]}</h5>
                    </div>
                    <div className="loginrow mt-2">
                        <a
                            style={{
                                textDecoration: 'none',
                                textAlign: 'center'
                            }}
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                        >
                            Back to Login
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
